import React from "react";
import "./ContactPage.css";

const ContactPage: React.FC = () => {
  return (
    <section className="nw-contact-page">
      <div className="nw-contact-map">
        <iframe
          title="Goodhand Government Center Location"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d230929.86243816855!2d55.327359!3d25.261195!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5cdadcbbb60f%3A0x7825f27cc5151615!2zQWwgQWRoZWVk!5e0!3m2!1sen!2sae!4v1760700841050!5m2!1sen!2sae&output=embed&z=13&maptype=roadmap"
          style={{
            width: "100%",
            height: "500px",
            border: "0",
            filter: "grayscale(1) brightness(0.9)",
            pointerEvents: "none", // disables user controls (scroll/zoom)
          }}
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div>

      <div className="nw-help-section">
        <div className="container">
          <h2 className="font-25 ff-semibold text-center mb-2">
            We’re here to help
          </h2>
          <p className="font-14 ff-regular text-center nw-help-desc mb-5">
            From Amer and Tasheel specialists to Tawjeeh consultants and visa
            service experts, our professional team at Good Hand Government
            Transactions LLC is here to assist you. Whether you need help with
            document processing, labor services, or immigration support, we’re
            just a call away. If you’re not sure which department to contact,
            our Customer Service team will gladly guide you to the right expert.
          </p>
          <div className="row justify-content-center g-4">
            <div className="col-md-5">
              <div className="nw-info-box bg-3 text-center  h-100 d-flex align-items-center flex-column gap-3">
                <h4 className="font-20 text-main ff-semibold mb-3">
                  Goodhand Government LLC
                </h4>
                <p className="font-14 ff-regular mb-2">
                  <i className="bi bi-clock"></i> Open until 08:00 PM
                </p>
                <p className="font-14 ff-regular mb-2">
                  <i className="bi bi-geo-alt"></i> M-01 Saraya Plaza, Al Rigga
                  Road, Al Rigga - Dubai
                </p>
                <a
                  href="tel:+97142979997"
                  className="d-block font-14 ff-regular text-black"
                >
                  <i className="bi bi-telephone"></i> +971 4 297 9997
                </a>
                <a
                  href="tel:+97142990998"
                  className="d-block font-14 ff-regular text-black"
                >
                  <i className="bi bi-telephone"></i> +971 4 297 9098
                </a>
                <a
                  href="mailto:contact@goodhand.ae"
                  className="d-block font-14 ff-regular text-black"
                >
                  <i className="bi bi-envelope"></i> contact@goodhand.ae
                </a>
              </div>
            </div>
            <div className="col-md-5">
              <div className="nw-info-box bg-3 text-center h-100 d-flex align-items-center flex-column gap-3">
                <h4 className=" font-20 text-main ff-semibold mb-3">
                  Talk with Expert
                </h4>
                <p className="font-14 ff-regular mb-2">
                  Search our team of 10+ visa experts to get professional
                  guidance.
                </p>
                <a
                  href="tel:+971523345697"
                  className="d-block font-14 ff-regular text-black"
                >
                  <i className="bi bi-telephone"></i> +971 52 334 5697
                </a>
                <a
                  href="mailto:expert@goodhand.ae"
                  className="d-block font-14 ff-regular text-black"
                >
                  <i className="bi bi-envelope"></i> expert@goodhand.ae
                </a>
                <button className="nw-chat-btn ff-medium font-14 mt-3">
                  CHAT WITH EXPERT
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
